<template>
  <v-container
    fluid
  >
    <v-card-title>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        :label="$t('search')"
        single-line
        hide-details
        class="mb-2"
      />
    </v-card-title>
    <v-data-table
      :headers="headers"
      :items="dataRows"
      :items-per-page="tableCPP"
      :search="search"
      :loading="loading"
      class="elevation-1"
    >
      <template v-slot:item.actions="{ item }">
        <v-btn-toggle class="me-2">
          <v-btn
            fab
            x-small
            class="indigo"
            @click="showItem(item)"
          >
            <i
              class="fal fa-eye fa-lg"
            />
          </v-btn>
          <v-btn
            fab
            x-small
            class="error"
            @click="deleteConfirm(item)"
          >
            <i
              class="fal fa-trash-alt fa-lg"
            />
          </v-btn>
        </v-btn-toggle>
      </template>
      <template v-slot:item.is_read_text="{ item }">
        <v-chip
          :color="getStatusColor(item.is_read_text)"
        >
          {{ $t(item.is_read_text) }}
        </v-chip>
      </template>
      <template v-slot:item.created_at="{ item }">
        {{ item.created_at | moment("jYYYY/jM/jD HH:mm") }}
      </template>
    </v-data-table>
    <v-dialog
      v-model="dialogShow"
      :persistent="true"
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-card-text
          id="printDiv"
        >
          <v-container>
            <v-row>
              <v-col
                cols="12"
                sm="12"
                md="2"
              >
                {{ $t('id') }} : <strong>{{ editedItem.id }}</strong>
              </v-col>
              <v-col
                cols="12"
                sm="12"
                md="10"
              >
                {{ $t('form_title') }} : <strong>{{ editedItem.form_title }}</strong>
              </v-col>
              <v-col
                cols="12"
                sm="6"
                md="4"
              >
                {{ $t('ip') }} : <strong>{{ editedItem.ip }}</strong>
              </v-col>
              <v-col
                cols="12"
                sm="6"
                md="4"
              >
                {{ $t('duration') }} : <strong>{{ editedItem.duration }}</strong>
              </v-col>
            </v-row>
            <v-row>
              <v-col
                cols="12"
                sm="6"
                md="4"
              >
                {{ $t('created_at') }} : <strong>{{ editedItem.created_at | moment("jYYYY/jM/jD HH:mm") }}</strong>
              </v-col>
              <v-col
                cols="12"
                sm="6"
                md="4"
              >
                {{ $t('updated_at') }} : <strong>{{ editedItem.updated_at | moment("jYYYY/jM/jD HH:mm") }}</strong>
              </v-col>
            </v-row>
            <v-divider />
            <v-row>
              <v-col
                v-for="item in editedItem.form_result_details"
                :key="item.id"
                cols="12"
                sm="12"
                md="12"
              >
                {{ item.title }} : <strong>{{ item.result }}</strong>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer />
          <v-btn
            color="blue darken-1"
            text
            @click="print"
          >
            {{ $t('print') }}
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            :loading="btnLoadingSave"
            :disabled="btnLoadingSave"
            @click="save"
          >
            {{ editedItem.is_read ? $t('mark_as_unread') : $t('mark_as_read') }}
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            @click="close"
          >
            {{ $t('close') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <div class="text-center">
      <v-bottom-sheet
        v-model="deleteSheet"
        persistent
        inset
      >
        <v-sheet
          class="text-center"
          height="200px"
        >
          <v-btn
            class="mt-6"
            color="error"
            :loading="btnLoadingDelete"
            :disabled="btnLoadingDelete"
            @click="deleteItem(editedItem)"
          >
            {{ $t('delete') }}
          </v-btn>
          <v-btn
            class="mt-6 ms-2"
            color="green"
            @click="deleteSheet = !deleteSheet"
          >
            {{ $t('close') }}
          </v-btn>
          <div class="py-3">
            {{ $t('permanently_delete?') }} {{ $t('you_can_not_undo.') }}
            <p class="pt-3">
              {{ $t('id') }} : <strong>{{ editedItem.id }}</strong> ,
              {{ $t('title') }} : <strong>{{ editedItem.title }}</strong>
            </p>
          </div>
        </v-sheet>
      </v-bottom-sheet>
    </div>
    <v-snackbar
      v-model="snackbar"
      :color="snackbarColor"
      :timeout="6000"
    >
      {{ snackbarText }}
      <template v-slot:action="{ attrs }">
        <v-btn
          dark
          text
          tile
          small
          outlined
          v-bind="attrs"
          @click="snackbar = false"
        >
          {{ $t('close') }}
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>

  export default {
    name: 'Operations',
    data () {
      return {
        headers: [],
        dataRows: [],
        dynamicColumns: [],
        tableCPP: 0,
        search: '',
        loading: true,
        dialog: false,
        dialogShow: false,
        btnLoadingSave: false,
        dialogDetail: false,
        editedIndex: -1,
        editedItem: {},
        defaultItem: {},
        formTitle: '',
        deleteSheet: false,
        btnLoadingDelete: false,
        snackbar: false,
        snackbarColor: '', // ['success', 'info', 'error', 'cyan darken-2']
        snackbarText: '',
      }
    },
    async created () {
      await this.getData()
      await this.getHeaders()
      await this.getOptions()
    },
    methods: {
      getOptions () {
        this.$http.post('options/showByTitle', {
          title: 'Forms-Results-CPP',
        }).then(
          response => {
            const result = response.data.Option
            this.tableCPP = parseInt(result.value)
          },
          error => {
            if (error.data.code === 2001) {
              this.$router.push('/login')
            } else {
              this.snackbarColor = 'error'
              this.snackbarText = this.$t('server_error') + ': options/showByTitle|901'
              this.snackbar = true
            }
          }).catch(error => {
          this.snackbarColor = 'error'
          this.snackbarText = this.$t('server_error') + ': options/showByTitle|902'
          this.snackbar = true
          console.log(error)
        })
      },
      getHeaders () {
        this.$http.post('options/showTableHeader', {
          title: 'Forms-TH-Results',
        }).then(
          response => {
            const result = response.data.Option
            this.headers = []
            this.headers.push({ text: this.$t('id'), value: 'id' })
            result.forEach(o => {
              this.headers.push({
                text: this.$t(o.value),
                value: o.value,
              })
            })
            this.headers.push({ text: this.$t('actions'), value: 'actions', sortable: false })
          },
          error => {
            if (error.data.code === 2001) {
              this.$router.push('/login')
            } else {
              this.snackbarColor = 'error'
              this.snackbarText = this.$t('server_error') + ': options/showTableHeader|901'
              this.snackbar = true
            }
          }).catch(error => {
          this.snackbarColor = 'error'
          this.snackbarText = this.$t('server_error') + ': options/showTableHeader|902'
          this.snackbar = true
          console.log(error)
        })
      },
      getData () {
        this.$http.post('forms/indexResults').then(
          response => {
            this.dataRows = response.data.FormResults
            this.editedItem = Object.assign({}, this.dataRows[0])
            const tempArray = []
            Object.keys(this.editedItem).forEach(function (item) {
              Object.assign(tempArray, { [item]: null })
            })
            this.defaultItem = tempArray
            this.loading = false
          },
          error => {
            if (error.data.code === 2001) {
              this.$router.push('/login')
            } else {
              this.snackbarColor = 'error'
              this.snackbarText = this.$t('server_error') + ': forms/index|901'
              this.snackbar = true
            }
          }).catch(error => {
          this.snackbarColor = 'error'
          this.snackbarText = this.$t('server_error') + ': forms/index|902'
          this.snackbar = true
          console.log(error)
        })
      },
      deleteConfirm (item) {
        this.editedItem = Object.assign({}, item)
        this.deleteSheet = true
      },
      showItem (item) {
        this.editedItem = Object.assign({}, item)
        this.editedIndex = this.dataRows.indexOf(item)
        this.dialogShow = true
      },
      deleteItem (item) {
        this.btnLoadingDelete = true
        this.$http.post('forms/deleteResults', {
          id: item.id,
        }).then(
          response => {
            const index = this.dataRows.indexOf(this.dataRows.find(x => x.id === item.id))
            this.dataRows.splice(index, 1)
            this.deleteSheet = false
            this.btnLoadingDelete = false
            this.snackbarColor = 'success'
            this.snackbarText = this.$t('item_deleted')
            this.snackbar = true
          },
          error => {
            if (error.data.code === 2001) {
              this.$router.push('/login')
            } else {
              this.btnLoadingDelete = false
              this.snackbarColor = 'error'
              this.snackbarText = this.$t('server_error') + ': forms/delete|901'
              this.snackbar = true
            }
          }).catch(error => {
          this.btnLoadingDelete = false
          this.snackbarColor = 'error'
          this.snackbarText = this.$t('server_error') + ': forms/delete|902'
          this.snackbar = true
          console.log(error)
        })
      },
      close () {
        this.dialogShow = false
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      },
      save () {
        this.btnLoadingSave = true
        if (this.editedItem.is_read) {
          this.editedItem.is_read_text = 'unread'
        } else {
          this.editedItem.is_read_text = 'read'
        }
        this.editedItem.is_read = !this.editedItem.is_read
        this.$http.post('forms/updateResults', this.editedItem).then(
          response => {
            Object.assign(this.dataRows[this.editedIndex], this.editedItem)
            this.btnLoadingSave = false
            this.snackbarColor = 'success'
            this.snackbarText = this.$t('item_updated')
            this.snackbar = true
            this.close()
          },
          error => {
            if (error.data.code === 2001) {
              this.$router.push('/login')
            } else {
              this.btnLoadingSave = false
              this.snackbarColor = 'error'
              this.snackbarText = this.$t('server_error') + ': forms/update|901'
              this.snackbar = true
            }
          }).catch(error => {
          this.btnLoadingSave = false
          this.snackbarColor = 'error'
          this.snackbarText = this.$t('server_error') + ': forms/update|902'
          this.snackbar = true
          console.log(error)
        })
      },
      getStatusColor (text) {
        let returnColor
        switch (text) {
          case 'unread':
            returnColor = 'red'
            break
          case 'read':
            returnColor = 'green'
            break
          default:
            returnColor = 'yellow'
        }
        return returnColor
      },
      print () {
        this.$htmlToPaper('printDiv')
      },
    },
  }
</script>
